import { render } from "./SkeletonCpdTokenTabLoader.vue?vue&type=template&id=c84a8322"
import script from "./SkeletonCpdTokenTabLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonCpdTokenTabLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__